/**
 * Retorna hoje no fuso local no formato YYYY-MM-DD
 */
export function hojeStr(): string {
  const d = new Date()
  return formatDate(d)
}

export function formatDate(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/**
 * Retorna se a data (YYYY-MM-DD) é anterior a hoje
 */
export function isDataPassada(dateStr: string): boolean {
  return dateStr < hojeStr()
}

/** 0 = domingo … 6 = sábado (mesma convenção que `disponibilidade.dia_semana`). */
export function diaSemanaFromDateStr(dateStr: string): number {
  const d = new Date(`${String(dateStr).trim()}T12:00:00`)
  if (Number.isNaN(d.getTime())) return -1
  return d.getDay()
}

/**
 * Retorna os dias para exibir no calendário de um mês (inclui dias do mês anterior/próximo para preencher a grade).
 * Semana começa no domingo (0).
 */
export function getDiasDoMes(year: number, month: number): Array<{
  dateStr: string
  day: number
  isCurrentMonth: boolean
  isPast: boolean
}> {
  const first = new Date(year, month, 1)
  const last = new Date(year, month + 1, 0)
  const startWeekday = first.getDay()
  const totalDays = last.getDate()
  const hoje = hojeStr()

  const result: Array<{ dateStr: string; day: number; isCurrentMonth: boolean; isPast: boolean }> = []

  // Dias vazios do mês anterior (domingo = 0)
  const prevMonth = month === 0 ? 11 : month - 1
  const prevYear = month === 0 ? year - 1 : year
  const prevLast = new Date(prevYear, prevMonth + 1, 0).getDate()
  for (let i = startWeekday - 1; i >= 0; i--) {
    const day = prevLast - i
    const dateStr = formatDate(new Date(prevYear, prevMonth, day))
    result.push({
      dateStr,
      day,
      isCurrentMonth: false,
      isPast: dateStr < hoje,
    })
  }

  // Dias do mês atual
  for (let day = 1; day <= totalDays; day++) {
    const dateStr = formatDate(new Date(year, month, day))
    result.push({
      dateStr,
      day,
      isCurrentMonth: true,
      isPast: dateStr < hoje,
    })
  }

  // Completar até 6 linhas (42 células) com dias do próximo mês
  const nextMonth = month === 11 ? 0 : month + 1
  const nextYear = month === 11 ? year + 1 : year
  let nextDay = 1
  while (result.length < 42) {
    const dateStr = formatDate(new Date(nextYear, nextMonth, nextDay))
    result.push({
      dateStr,
      day: nextDay,
      isCurrentMonth: false,
      isPast: dateStr < hoje,
    })
    nextDay += 1
  }

  return result
}

const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
]

export function getNomeMes(month: number): string {
  return MESES[month]
}

/**
 * Retorna se o horário (ex: "14:00") já passou na data dada (YYYY-MM-DD).
 * Se a data for no futuro, nenhum horário é passado.
 */
export function isHorarioPassado(dateStr: string, horario: string): boolean {
  const hoje = hojeStr()
  if (dateStr !== hoje) return false
  const [h, m] = horario.split(':').map(Number)
  const now = new Date()
  const nowMinutes = now.getHours() * 60 + now.getMinutes()
  const slotMinutes = h * 60 + m
  return slotMinutes <= nowMinutes
}
